/**
 * Shared mobile breakpoint (matches .carousel-desktop / .carousel-mobile CSS).
 */
export const MOBILE_MAX_WIDTH = 767;

export function getIsMobile() {
  if (typeof window === 'undefined') return false;
  return window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`).matches;
}

export function subscribeIsMobile(callback) {
  if (typeof window === 'undefined') return () => {};
  const mql = window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`);
  const handler = (e) => callback(e.matches);
  callback(mql.matches);
  if (mql.addEventListener) mql.addEventListener('change', handler);
  else mql.addListener(handler);
  return () => {
    if (mql.removeEventListener) mql.removeEventListener('change', handler);
    else mql.removeListener(handler);
  };
}
